// VozDemo.jsx
// Sección de la landing dedicada a contarle la comida hablando. Es hermana de
// <AsistenteDemo />: misma estructura y mismas clases, para que las dos se lean
// igual y no haya dos maquetaciones que mantener.
//
// ⚠️ El reel TIENE que ir dentro de `.asistente-inner`. Su escala se calcula a
// partir del ancho disponible, así que colgado suelto en la portada se dibuja
// a pantalla completa, gigante.
import React from "react";
import VozReel from "./VozReel";
import "./AsistenteDemo.css"; // el envoltorio: cabecera, contenedor, tipografía
import "./VozReel.css";

export default function VozDemo() {
  return (
    <section className="asistente voz-demo" id="hablar">
      <div className="asistente-inner">
        <header className="asistente-header">
          <span className="asistente-badge">Nuevo · Háblale</span>
          <h2 className="asistente-title">
            Ni siquiera hace falta la foto.
            <br />
            <span className="title-highlight">Cuéntaselo y ya está</span>
          </h2>
          <p className="asistente-sub">
            Dile lo que has comido como se lo dirías a un amigo. Wayo lo entiende, te lo desglosa
            alimento por alimento y lo apunta en tu diario.
          </p>
        </header>

        <VozReel />
      </div>
    </section>
  );
}
